import React, { useState, useRef, Dispatch, SetStateAction, useEffect } from "react";
import './pageInfo.css'

import { FiEye, FiEyeOff } from "react-icons/fi";
import DOMPurify from 'dompurify';
import { getPurifyMail, isArrayCodeFull, passwordPattern } from "../../../components/types/types";
import InputForm from "../../../components/inputForm/InputForm";

interface PageInfoProps {
    validPage:(id:number) => void,
    token:string,
    emailVerifiedStart:boolean,
    emailAvailable:boolean,
    namestart:string,
    mailStart:string,
    firstNamestart:string,
    setNameStart: Dispatch<SetStateAction<string>>,
    setFirstNameStart: Dispatch<SetStateAction<string>>,
    setMailStart: Dispatch<SetStateAction<string>>,
    birthStart:[string,string,string],
    setBirthStart:Dispatch<SetStateAction<[string,string,string]>>,
}

const PageInfo:React.FC<PageInfoProps> = ({validPage,token,emailVerifiedStart,emailAvailable,namestart,firstNamestart,mailStart,birthStart,setBirthStart,setNameStart,setFirstNameStart,setMailStart}) => {

    const [password,setPassword] = useState('')
    const [confirmPassword,setConfirmPassword] = useState('')

    const [validName, setValidName] = useState(true)
    const [validFirstName, setValidFirstName] = useState(true)
    const [validDate, setValidDate] = useState(true)
    const [validMail,setValidMail] = useState(true)
    const [validPassword,setValidPassword] = useState(true)
    const [validConfirmPassword,setValidConfirmPassword] = useState(true)
    const [showPassword,setShowPassword] = useState(false)
    const [showPasswordConfirm,setShowPasswordConfirm] = useState(false)
    const [alreadyMail,setAlreadyMail] = useState(false)

    const dayRef = useRef<HTMLInputElement>(null);
    const monthRef = useRef<HTMLInputElement>(null);
    const yearRef = useRef<HTMLInputElement>(null);

    const [patternPassword,setPatternPassword] = useState(false)

    const [showVerifCode,setShowVerifCode] = useState(false)
    const [code, setCode] = useState<string[]>(Array(6).fill(''));
    const [verificationError,setVerificationError] = useState(false)
    const [msgVerifError,setMsgVerifError] = useState('')

    const handleChangePwd = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value)
        if(!validPassword) { 
            if(password.length >= 5 ) setValidPassword(true)
        }
    }
    const handleChangePwdConfirm = (e: React.ChangeEvent<HTMLInputElement>) => {
        setConfirmPassword(e.target.value)
        if(!validConfirmPassword) {
            if(e.target.value === password ) setValidConfirmPassword(true)
        }
    }

    const clickShowPassword = (id:string,confirm:boolean=false) => {
        confirm ? setShowPasswordConfirm(!showPasswordConfirm) : setShowPassword(!showPassword);
        const passwordInput = document.getElementById(id)
        if(passwordInput) {
            let type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password' 
            passwordInput.setAttribute('type', type);
        }
    }

    useEffect(() => {
        if(alreadyMail) setAlreadyMail(false)
    },[mailStart])

    const clickRegister = async () => {
        if(namestart.length < 2 || namestart.length > 30) setValidName(false)
        else setValidName(true)
        if(firstNamestart.length < 2 || firstNamestart.length > 30) setValidFirstName(false)
        else setValidFirstName(true)

        const dayNum = Number(birthStart[0]);
        const monthNum = Number(birthStart[1]) - 1;
        const yearNum = Number(birthStart[2]);

        const date = new Date(yearNum, monthNum, dayNum);
        const isValid =
            date.getFullYear() === yearNum &&
            date.getMonth() === monthNum &&
            date.getDate() === dayNum;
        let age = 0;
        if (!isValid) {
            setValidDate(false);
        } else {
            const today = new Date()
            age = today.getFullYear() - date.getFullYear();
            const birthdayThisYear = new Date(today.getFullYear(), date.getMonth(), date.getDate());

            if (today < birthdayThisYear) {
                age--;
            }

            if (age  < 18 || age  > 140) setValidDate(false);
            else setValidDate(true);
        }


        var regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const emailTest = getPurifyMail(mailStart)
        if(!regex.test(emailTest)) setValidMail(false)
        else setValidMail(true)

        if(password.length < 8) setValidPassword(false)
        else setValidPassword(true)

        if(confirmPassword !== password) setValidConfirmPassword(false)
        else setValidConfirmPassword(true)


        if(namestart.length >= 2 && namestart.length <= 30  && regex.test(emailTest) && password.length >= 8 && confirmPassword === password && (age  >= 18 && age  <= 140)  && (date.getFullYear() === yearNum && date.getMonth() === monthNum && date.getDate() === dayNum)  ) {
            const cleanMail = getPurifyMail(mailStart)
            const cleanMdp = DOMPurify.sanitize(password);
            
            if (passwordPattern.test(cleanMdp)) {
                if(emailVerifiedStart) {
                    if(emailAvailable) await registerVerifMail(false)
                    else setAlreadyMail(true)
                    
                    return
                }
                try {
                    const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/send-code/verif-mail`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ email: cleanMail, needVerif:true }),
                    });
        
                    const data = await response.json();
                    if (data.success) {
                        setShowVerifCode(true); 
                    } else {
                        if(data.message === "already use") {
                            setAlreadyMail(true)
                        }
                        console.error("Erreur lors de l'envoi du code");
                    }
                } catch (error) {
                    console.error("Erreur lors de l'envoie du code' :", error);
                }
                
            }
            else {
                setPatternPassword(true)
            }


        }
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>,index:number) => {
         const value = e.target.value;
        
        if (value.match(/^[0-9]$/) || value === '') {
            const newCode = [...code];
            newCode[index] = value;
            setCode(newCode);
    
            if (value && index < 6 - 1) {
                document.getElementById(`code-input-${index + 1}`)?.focus();
            }

        }
    }
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>,index:number) => {
        if (e.key === 'Backspace' && !code[index] && index > 0) {
          document.getElementById(`code-input-${index - 1}`)?.focus();
        }
      };

    const registerVerifMail = async (shouldVerif=true) => {
        const cleanName = DOMPurify.sanitize(namestart);
        const cleanFirstName = DOMPurify.sanitize(firstNamestart);
        const dayNum = Number(birthStart[0]) +1;
        const monthNum = Number(birthStart[1]) - 1;
        const yearNum = Number(birthStart[2]);
        const cleanDate = new Date(yearNum, monthNum, dayNum);
        const cleanMail = getPurifyMail(mailStart);
        const cleanMdp = DOMPurify.sanitize(password);
        const cleanCode = DOMPurify.sanitize(code.join(''));
        try {
            const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/registerTemp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: cleanMail,
                    code:cleanCode,
                    name: cleanName,
                    firstname:cleanFirstName,
                    password: cleanMdp,
                    birthDate: cleanDate,
                    token: token,
                    shouldVerif,
                })
            });
    
            if (!response.ok) {
                return; 
            }
            const data = await response.json();
            if (data.success) {
                validPage(0)

            } else {
                if (data.message === 'Code de vérification incorrect') {
                    setVerificationError(true); 
                    setMsgVerifError('Le code est incorrect')
                } else if (data.message === 'Le code a expiré') {
                    setVerificationError(true); 
                    setMsgVerifError('Le code a expiré')
                } else if (data.message === 'Adresse mail déjà utilisée') {
                    setVerificationError(true); 
                    setMsgVerifError('L\'adresse mail est déjà utilisée')
                } 
                else {
                    console.error("Erreur lors de l'enregistrement de l'utilisateur :", data.message);
                }
            }
        } catch (error) {
            console.error("Erreur lors de la vérification du code:", error);
        }
    };

    const inputSearchKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if(event.key === 'Enter') clickRegister()
    }

    const handleReSend = () => {
        setCode(Array(6).fill(''))
        clickRegister();
        setVerificationError(false); 
        setMsgVerifError('')
    }
    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement>,
        nextRef: React.RefObject<HTMLInputElement> | null,
        maxLength: number
        ) => {
        const value = e.target.value.replace(/\D/g, ""); 
        if (value.length <= maxLength) {
            if (e.target.name === "day") setBirthStart(prev => [value,prev[1],prev[2]]) 
            if (e.target.name === "month") setBirthStart(prev => [prev[0],value,prev[2]]) 
            if (e.target.name === "year") setBirthStart(prev => [prev[0],prev[1],value]) 
        }
        if (value.length === maxLength && nextRef) setTimeout(() => {
            nextRef.current?.focus(); 
        },10) 
    };
    
    const inputStyleYear: React.CSSProperties = {
        width: "50px",
        textAlign: "left",
        border: "none",
        outline: "none",
        backgroundColor: "transparent",
    };
    return (
        
        <div className='pageInfo'>      
            <div className="corpForm">
                
                {!showVerifCode ?  <>
                    <InputForm value={firstNamestart} setValue={setFirstNameStart} PrimaryText="Prénom" SecondaryText="Prénom incorrect"  idInput="inputFirstName" placeHolder="Prénom" maxLength={30} valid={validFirstName} setValid={setValidFirstName}/>
                    <InputForm value={namestart} setValue={setNameStart} PrimaryText="Nom" SecondaryText="Nom incorrect"  idInput="inputName" placeHolder="Nom" maxLength={30} valid={validName} setValid={setValidName}/>
                    <p className="smallTextBold" style={validDate ? {} : {color : "red"}}>
                        { validDate ?
                            "Date de naissance" : "Rentrer une date valide" }
                    </p> 
                    <div className="inputContainerDate" style={validDate ? {} : {border: "1px solid red"}}>
                            <input
                                        ref={dayRef}
                                        name="day"
                                        type="text"
                                        value={birthStart[0]}
                                        onChange={(e) => handleChange(e, monthRef, 2)}
                                        onFocus={() => setBirthStart(prev => [prev[0].replace(/j/g, ''),prev[1],prev[2]])}
                                        onBlur={() => birthStart[0].length === 1 &&  setBirthStart(prev => [prev[0] + 'j',prev[1],prev[2]])} 
                                        maxLength={2}
                                        placeholder="jj"
                                        className="smallText"
                                        inputMode="numeric"
                                        pattern="\d*"
                                        style={{width:'20px'}}
                                    />
                                    <div className="midText">/</div>
  

                                    <input
                                        ref={monthRef}
                                        name="month"
                                        type="text"
                                        value={birthStart[1]}
                                        onChange={(e) => handleChange(e, yearRef, 2)}
                                        onFocus={() => setBirthStart(prev => [prev[0],prev[1].replace(/m/g, ''),prev[2]])}
                                        onBlur={() => birthStart[1].length === 1  && setBirthStart(prev => [prev[0],prev[1] + 'm',prev[2]])} 
                                        maxLength={2}
                                        className="smallText"
                                        placeholder="mm"
                                        inputMode="numeric"
                                        pattern="\d*"
                                        style={{width:birthStart[1].length === 0 ? '35px' : '24px',textAlign:'left'}}
                                    />
                                    <div className="midText">/</div>

                                    <input
                                        ref={yearRef}
                                        name="year"
                                        type="text"
                                        value={birthStart[2]}
                                        onFocus={() => setBirthStart(prev => [prev[0],prev[1],prev[2].replace(/a/g, '')])} 
                                        onChange={(e) => handleChange(e, null, 4)}
                                        onBlur={() => birthStart[2].length < 4 && birthStart[2].length > 0 && setBirthStart(prev => [prev[0],prev[1],prev[2] + 'a'.repeat(4 - birthStart[2].length)])}
                                        maxLength={4}
                                        className="smallText"
                                        placeholder="aaaa"
                                        inputMode="numeric"
                                        pattern="\d*"
                                        style={inputStyleYear}
                                    />
                    
                    
                    </div>
                    

                    {alreadyMail && <p className="smallTextBold" style={{color:'red',marginBottom:'-10px'}}>L'adresse e-mail est déjà utilisée</p>}
                    <InputForm value={mailStart} setValue={setMailStart}  PrimaryText="Adresse e-mail" SecondaryText="Adresse e-mail invalide" idInput="inputRegisterMail" placeHolder="E-mail" maxLength={254} valid={validMail} setValid={setValidMail}/>
                    
                    <p className="smallTextBold" style={validPassword ? {} : {color : "red"}}>
                        { validPassword ?
                            "Mot de passe" : "Le mot de passe doit contenir au moins 8 caractère" }
                        {
                            patternPassword && <>
                                <p className="patterPassword">Le mot de passe doit contenir une majuscule</p>
                                <p className="patterPassword">Le mot de passe doit contenir un chiffre</p>
                                <p className="patterPassword">Le mot de passe doit contenir un caractère spécial (!, @, #, $, %, *, /, ^, .).</p>
                            </>
                        }
                    </p>  
                    <div className="inputContainer" style={validPassword ? {} : {border: "1px solid red"}}>
                        <input type="password" className="smallText inputLogin" id="inputRegisterPassword" value={password} onChange={handleChangePwd} placeholder="Mot de passe"  maxLength={128}/>
                        {showPassword ? <FiEyeOff className="eyeInput pointer" size={25} onClick={() => clickShowPassword("inputRegisterPassword")}/> : <FiEye className="eyeInput pointer" size={25} onClick={() => clickShowPassword("inputRegisterPassword")}/>}
                    </div>

                    <p className="smallTextBold " style={validConfirmPassword ? {} : {color : "red"}}>
                        { validConfirmPassword ?
                            "Confirmer le mot de passe" : "Mot de passe différent" }
                        
                    </p> 
                    <div className="inputContainer" style={validConfirmPassword ? {} : {border: "1px solid red"}}>
                        <input type="password" className="smallText inputLogin" id="inputRegisterConfirmPassword" value={confirmPassword} onChange={handleChangePwdConfirm} onKeyDown={inputSearchKeyDown}   placeholder="Mot de passe"  maxLength={128}/>
                        {showPasswordConfirm ? <FiEyeOff className="eyeInput pointer" size={25} onClick={() => clickShowPassword("inputRegisterConfirmPassword",true)}/> : <FiEye className="eyeInput pointer" size={25} onClick={() => clickShowPassword("inputRegisterConfirmPassword",true)}/>}
                    </div>

                    <div className="containerButton" >
                        <div className={`buttonNext midText longWhiteButton`}  onClick={clickRegister} >Suivant</div>
                    </div>
                    </>
                    :
                    <div className="containerValidMail">
                        <div className="largeText" style={{ textAlign:'center',marginTop:'3em'}}>Un code a été envoyé à l'adresse <i className="midText">"{DOMPurify.sanitize(mailStart)}"</i></div>
                        <p className="midText">Entrer le code de vérification</p>
                        <div className="code">
                            {code && code.map((digit, index) => (
                                <input
                                key={index}
                                id={`code-input-${index}`}
                                type="text"
                                maxLength={1}
                                value={digit}
                                onChange={(e) => handleInputChange(e, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                className="verification-code-input"
                                inputMode="numeric"
                                pattern="\d*"
                                />
                            ))}
                        </div>
                        {verificationError && <p className="smallTextBold" style={{color:'red'}}>{msgVerifError}</p>}
                        <p  className={`button midText smallWhiteButton ${isArrayCodeFull(code) ? 'smallGoldButton' : 'isLockButton'}`} style={{ marginBottom:'5px'}} onClick={() => registerVerifMail()}>Valider</p>

                        <p className="validCode smallText lowOpacityHover pointer" onClick={handleReSend}>Renvoyer un code</p>
                    </div>
                }
            </div>
        </div>

    )
}


export default PageInfo